/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {
    
    export interface IObjectQueryRestrictionsScope extends angular.IScope {
        processConfigurationId: string;
        objectQuery: Wars.Domain.Model.ObjectQuery;
        parentRestriction: Wars.Domain.Model.ObjectQueryRestriction;
        topLevel: boolean;
        model: models.ObjectQueryRestrictionsModel;
    }

    export class ObjectQueryRestrictions implements IDirective {

        link($scope: IObjectQueryRestrictionsScope, element: JQuery, attrs: angular.IAttributes, controller: ObjectQueryRestrictionsController) { }
        templateUrl = "./app/views/directives/objectQueryRestrictions.html";
        restrict = "E";
        controller = ["$scope", "growl", "systemLevelService", "applicationCodeService", "treeService", "objectQueryService", ObjectQueryRestrictionsController];
        scope = {
            processConfigurationId: "=",  
            objectQuery: "=",
            parentRestriction: "=",
            topLevel: "="
        }; 
        compile = (element) => {
            return this.recursionHelper.compile(element);
        }
        
        private recursionHelper: any;

        constructor(recursionHelper: any) {
            this.recursionHelper = recursionHelper;
        }
    }

    export class ObjectQueryRestrictionsController implements IController {

        private scope: IObjectQueryRestrictionsScope;
        
        constructor(
            $scope: IObjectQueryRestrictionsScope,
            growl: angular.growl.IGrowlService,
            systemLevelService: services.SystemLevelService,
            applicationCodeService: services.ApplicationCodeService,
            treeService: services.TreeService,
            objectQueryService: services.ObjectQueryService)
        {
            var self = this;
            self.scope = $scope;
            self.scope.model = new models.ObjectQueryRestrictionsModel(self.scope, growl, systemLevelService, applicationCodeService, treeService, objectQueryService);
        }
    }
}

warsApp.registerDirective("ObjectQueryRestrictions", ["recursionHelper"]);